import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Box, Stack, Typography } from 'styles';
import { useTheme } from 'stylesHooks';
import { useTranslation } from 'utils/translations';

const boxSX = {
	display: 'block',
	justifyContent: 'space-between',
	alignItems: 'flex-start',
	alignSelf: 'stretch',
	whiteSpace: 'break-spaces',
	padding: '5px 20px',
	width: '100%',
	overflowWrap: 'break-word',
};

const PaymentFrom = () => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	const theme = useTheme();

	const { paymentDetails } = useSelector((store: RootState) => store.payment);

	return (
		<Stack
			display={'flex'}
			flexDirection={'column'}
			alignItems={'flex-start'}
			flex={'1 0 0'}
			gap={theme.spacing(2.5)}
		>
			<Stack direction={'column'} gap={theme.spacing(0.25)} width="100%">
				<Box sx={boxSX} borderRadius={'4px'} bgcolor={theme.palette.white.main}>
					<Typography variant="bodyLink">
						{paymentDetails.from.name || ''}
					</Typography>
				</Box>
				<Box sx={boxSX}>
					<Typography variant="body">
						{tDbLabels(paymentDetails.from.companyDescription) || ''}
					</Typography>
				</Box>
				<Box sx={boxSX}>
					<Stack direction={'column'}>
						<Typography variant="body" textTransform={'uppercase'}>{`${
							tDbLabels(paymentDetails.from.shareCapital) || ''
						}`}</Typography>
						<Typography variant="body" textTransform={'uppercase'}>{`${tClientLabels(
							'payment_run.taxCode',
						)} - ${tClientLabels('payment_run.vat')} ${
							paymentDetails.from.tin || ''
						}`}</Typography>
					</Stack>
				</Box>
				<Box sx={boxSX}>
					<Stack direction={'column'}>
						<Typography variant="body">{paymentDetails.from.street || ''}</Typography>
						<Typography variant="body">{`${paymentDetails.from.postalCode || ''} ${
							paymentDetails.from.city || ''
						} ${paymentDetails.from.region ? `(${paymentDetails.from.region})` : ''}`}</Typography>
					</Stack>
				</Box>
			</Stack>
		</Stack>
	);
};

export default PaymentFrom;
